import PropTypes from 'prop-types'
import { settingPropType } from './setting-prop-type'
import { pressureUnitPropType } from './pressure-units-prop-types'
import { temperatureUnitPropType } from './units-prop-types'

/**
 * @typedef {Object} Settings
 * @property {Object<string, Setting>}
 */
export const settingsPropType = PropTypes.shape({
    AccountLocale: settingPropType,
    AddressColorLabels: settingPropType,
    AllowWirelessDriverTerminalUpdates: settingPropType,
    AtlantisUiNonFunctionalLimitAddresses: settingPropType,
    AtlantisUserTrackingAnonymous: settingPropType,
    AtlantisUserTrackingById: settingPropType,
    AutomaticDriverCreationFromDriverCardEnabled: settingPropType,
    AvailableApplications: settingPropType,
    AvgFuelConsumption: settingPropType,
    BlockingUserEnabled: settingPropType,
    CANCheckUrl: settingPropType,
    CANCompatibilityCheckEnabled: settingPropType,
    CoBrandingStyle: settingPropType,
    CommuteToWorkEnabled: settingPropType,
    ContractAdministrationEnabled: settingPropType,
    ContractAdministrationFeaturesLink: settingPropType,
    ContractAdministrationProductsLink: settingPropType,
    ContractAdministrationReOrderEnabled: settingPropType,
    ContractAdministrationServicesLink: settingPropType,
    CustomCouplingRuleDefaultDuration: settingPropType,
    DcsTncLinkLanguageMapping: settingPropType,
    DcsTncLinkTemplateDevMgr: settingPropType,
    DefaultAccountLanguage: settingPropType,
    DisableCouplingDetection: settingPropType,
    DistUnit: settingPropType,
    DriverCreationSourceManagementEnabled: settingPropType,
    DriverKeyInsertionValidationsBitMask: settingPropType,
    DriverScoreBounds: settingPropType,
    DriverScoreTrendBounds: settingPropType,
    DriverScoreWeights: settingPropType,
    DriverScoreWeightsEnabled: settingPropType,
    DriverWhiteListingManagementEnabled: settingPropType,
    'DrivingLicenseCheck.Interval.days': settingPropType,
    'DrivingLicenseCheck.Notification.days': settingPropType,
    DutchLogbookEnabled: settingPropType,
    EnableDriverPrivacyOnPrivateData: settingPropType,
    EnableManualCoupling: settingPropType,
    EtaNotification: settingPropType,
    FeatureAdministrationEditEnabled: settingPropType,
    FeatureAdministrationEnabled: settingPropType,
    FuelDifferenceReportingEnabled: settingPropType,
    FuelEfficiencyUnit: settingPropType,
    FuelLevelDecreasedLeakageEventLevel: settingPropType,
    FuelLevelDecreasedLeakageEventThreshold: settingPropType,
    FuelLevelIncreasedRefuelEventLevel: settingPropType,
    FuelType: settingPropType,
    GeocodeServiceProvider: settingPropType,
    HiddenKPI: settingPropType,
    'Hide.Speed': settingPropType,
    HighRevvingThresholdDiesel: settingPropType,
    HighRevvingThresholdPetrol: settingPropType,
    InvoiceDeliveryTypeChangeable: settingPropType,
    InvoiceDisplayEnabled: settingPropType,
    IsCrashReportAvailable: settingPropType,
    IsLogbookEditableAfter7Days: settingPropType,
    IsSevenDayRuleSettingVisible: settingPropType,
    LandingPage: settingPropType,
    LowFuelEventLevel: settingPropType,
    LowFuelEventThreshold: settingPropType,
    LowFuelReportingEnabled: settingPropType,
    MapTileUrlTomTomNight: settingPropType,
    MapTileUrlTomTomStandard: settingPropType,
    NonManualDriverObjectAssignmentDetachEnabled: settingPropType,
    NumberOfWeekdays: settingPropType,
    ObjectGreyDays: settingPropType,
    ObjectTextMessagesLength: settingPropType,
    OrderAutomatedUIInteraction: settingPropType,
    OrderDeliveryJobTime: settingPropType,
    OrderOptimisationFreeClicks: settingPropType,
    OrderPickupJobTime: settingPropType,
    OrderRejectionAllowed: settingPropType,
    OrderServiceJobTime: settingPropType,
    PasswordExpirationDuration: settingPropType,
    PasswordExpirationDurationEnabled: settingPropType,
    PasswordExpirationReminder: settingPropType,
    PasswordExpirationReminderEnabled: settingPropType,
    PasswordMinComplexityScore: settingPropType,
    PasswordMinLength: settingPropType,
    PressureUnit: pressureUnitPropType,
    PushThrottlingIntervalInMilliseconds: settingPropType,
    'ReverseGeocode.TTRevGeoCode.ATL.UseNewResult': settingPropType,
    ScheduledReportContentProvider: settingPropType,
    SessionLifeTime: settingPropType,
    ShouldUseDriverForAppLogin: settingPropType,
    ShowDateTimeWithSeconds: settingPropType,
    ShowIncomingTextMessagePopup: settingPropType,
    SoundEnabled: settingPropType,
    SoundEnabledTextMessage: settingPropType,
    SoundTypes: settingPropType,
    SpeedLimitTolerance: settingPropType,
    SpeedingDisplayEnabled: settingPropType,
    SpeedingReportSpeedLimit: settingPropType,
    SuppressPrivateTrips: settingPropType,
    TachoCheckUrl: settingPropType,
    TachoShareFileFormat: settingPropType,
    TachoShareUIEnabled: settingPropType,
    TemperatureUnit: temperatureUnitPropType,
    TermsAndConditionsVersion: settingPropType,
    TermsAndConditionsVersionAcknowledged: settingPropType,
    TimeZone: settingPropType,
    TooltipsEnabled: settingPropType,
    UseNewGeoCodeResult: settingPropType,
    'Vbm.enableMaintenanceTaskCreation': settingPropType,
    VehicleMarkerLabelColorActive: settingPropType,
    VehicleMarkerPinColorActive: settingPropType,
    VehicleSelection: settingPropType,
    VehicleSwapEnabled: settingPropType,
    WebfleetHelpCenterBaseUrl: settingPropType,
    allowReassignDriverToTrip: settingPropType,
    showFleetwinMigrationDialog: settingPropType
})
